/* SIFI BEAUVOIS — Product Specs — reveal du titre + accordéons animés (WAAPI)
   + resynchronisation de la section au switch de variante (écoute sifi:variant-switched). */
(function () {
  'use strict';

  function initProductSpecsTitleReveal(root, immediate) {
    var scope = root || document;
    var items = Array.prototype.slice.call(
      scope.querySelectorAll('[data-sb-specs-title-reveal]')
    );

    if (!items.length) return;

    var reducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (
      immediate ||
      reducedMotion ||
      !('IntersectionObserver' in window)
    ) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          items.forEach(function (item) {
            item.classList.add('is-visible');
          });

          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    var wrapper = scope.matches &&
      scope.matches('[data-sb-product-specs-wrapper]')
        ? scope
        : scope.querySelector('[data-sb-product-specs-wrapper]');

    if (wrapper) {
      observer.observe(wrapper);
    } else {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }
  }

  // --- Accordéon specs : ouverture/fermeture animée (hauteur, WAAPI) ---
  function initSpecsAccordion(root) {
    var scope = root || document;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scope.querySelectorAll('.sb-specs-toggle').forEach(function (item) {
      if (item.dataset.sbSpecsAccInit === '1') return;
      item.dataset.sbSpecsAccInit = '1';

      var summary = item.querySelector('summary');
      var content = item.querySelector('.sb-specs-toggle__content');
      if (!summary || !content) return;

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      function onFinish(open) {
        item.open = open;
        animation = null;
        isClosing = false;
        isExpanding = false;
        item.style.height = '';
        item.style.overflow = '';
      }

      function shrink() {
        isClosing = true;
        var startHeight = item.offsetHeight + 'px';
        var endHeight = summary.offsetHeight + 'px';
        if (animation) animation.cancel();
        animation = item.animate(
          { height: [startHeight, endHeight] },
          { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        animation.onfinish = function () { onFinish(false); };
        animation.oncancel = function () { isClosing = false; };
      }

      function expand() {
        isExpanding = true;
        var startHeight = item.offsetHeight + 'px';
        var endHeight = (summary.offsetHeight + content.offsetHeight) + 'px';
        if (animation) animation.cancel();
        animation = item.animate(
          { height: [startHeight, endHeight] },
          { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        animation.onfinish = function () { onFinish(true); };
        animation.oncancel = function () { isExpanding = false; };
      }

      function open() {
        item.style.height = item.offsetHeight + 'px';
        item.open = true;
        window.requestAnimationFrame(expand);
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (reduce) { item.open = !item.open; return; }
        item.style.overflow = 'hidden';
        if (isClosing || !item.open) open();
        else if (isExpanding || item.open) shrink();
      });
    });
  }

  function initProductSpecs() {
    initProductSpecsTitleReveal(document, false);
    initSpecsAccordion(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSpecs);
  } else {
    initProductSpecs();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductSpecsTitleReveal(event.target, false);
    initSpecsAccordion(event.target);
  });

  document.addEventListener('sifi:variant-switched', function (e) {
    var wrapper = document.querySelector('[data-sb-product-specs-wrapper]');
    if (!wrapper) return;

    var variantId = e.detail && e.detail.variantId;
    if (!variantId) return;

    var sectionId = wrapper.getAttribute('data-section-id');
    var productUrl = wrapper.getAttribute('data-product-url');
    if (!sectionId || !productUrl) return;

    var url =
      productUrl +
      '?variant=' +
      encodeURIComponent(variantId) +
      '&section_id=' +
      encodeURIComponent(sectionId);

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sb-product-specs-wrapper]');

        if (!fresh) return;

        wrapper.innerHTML = fresh.innerHTML;

        /* La variante change uniquement les données :
           le titre reste visible et l'animation ne se rejoue pas. */
        initProductSpecsTitleReveal(wrapper, true);
        initSpecsAccordion(wrapper);
      })
      .catch(function () {});
  });
})();